import { render, staticRenderFns } from "./ideasbox.vue?vue&type=template&id=3baa7474&"
import script from "./ideasbox.vue?vue&type=script&lang=js&"
export * from "./ideasbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports